// extracted by mini-css-extract-plugin
export default {"container":"styles_container__EZNmr","text":"styles_text__x5aw3"};